module.exports = __webpack_public_path__ + "img/poster1.33361309.png";